const theme = {
  colors: {
    primary: '#225055',    // Primary brand color
    secondary: '#FD8523',  // Secondary brand color
    accent: '#F79824',      // Accent brand color (for active states)
    background: '#f5f5f5', // Light background for main content
    text: '#000',           // Black text color for main content
    white: '#FFFFFF',
    gray: '#E7E7E7',
    grayDark: '#344054',
    grayLight: '#EFFEF9',
    grayDarker: '#181D27',
    success: '#0C8442',
    warning: '#D57507',
    error: '#C54709',
  },
  fonts: {
    body: 'Inter, sans-serif',
    heading: 'Arial, sans-serif',
  },
  fontSizes: {
    small: '0.8rem',
    medium: '1rem',
    large: '1.2rem',
    xlarge: '1.5rem',
    xxlarge: '2rem',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  // ... other theme properties like breakpoints, shadows, etc.
};

export default theme;